<template>
    <div id="loginBox">
        <div class="ornot_login">
            <div class="login_inner">
                <!-- 未登录 -->
                <div v-if="!areaUserinfo">
                  <div class="noLoginBox">
                      <!-- <p>登录后可以保存您的发布、评论、收藏，并与APP同步 同步更可以参加活动</p> -->
                      <!-- 手机登录和扫码登录 切换 -->
                      <p class="noLogintxt">登录后，内容更精彩</p>
                      <button class="btn" @click="login">登录</button>
                  </div>
                </div>
                <!-- 登录之后 -->
                <div v-else>
                  <div class="top clearfix" @click="intoPerson(areaUserinfo.openId)">
                    <!-- <img class="avatar fl" :src="userInfo.avatar" :οnerrοr="defaultImg" alt=""> -->
                        <img class="avatar fl" :src="areaUserinfo.avatar" @error="getdefaultImg" alt="">
                        <span class="username fl">{{areaUserinfo.username}}</span>
                  </div>
                  <div class="lcenter">
                    <div class="row" @click="intoPerson(areaUserinfo.openId)">
                      <p class="num">{{areaUserinfo.threadNum}}</p>
                      <p class="txt">帖子</p>
                    </div>
                    <div class="row">
                      <div v-if="areaUserinfo.levelInfo">
                          <div v-if="areaUserinfo.levelInfo.myInfo">
                              <p class="num">{{areaUserinfo.levelInfo.myInfo.currentLevel}}</p>
                          </div>
                      </div>
                      <p class="txt">{{areaUserinfo.groupName}}</p>
                    </div>
                    <div class="row">
                      <p class="num">{{areaUserinfo.coinNum}}</p>
                      <p class="txt">邻友币</p>
                    </div>
                  </div>
                  <!-- <div class="bottom" v-if="navsObj.site.id==1">
                    <div class="item">
                      <a :href="loginUrls.post_url" target="_blank">
                        <div>
                          <img class="icon" src="@/assets/imgs/ft.png" alt="">
                        </div>
                        <p class="txt">发帖</p>
                      </a>
                    </div>
                    <div class="item">
                      <a :href="loginUrls.pm_url" target="_blank">
                        <div>
                          <img class="icon" src="@/assets/imgs/xx.png" alt="">
                        </div>
                        <p class="txt" href="">消息</p>
                      </a>
                    </div>
                    <div class="item">
                      <a :href="loginUrls.notice_url" target="_blank">
                        <div>
                          <img class="icon" src="@/assets/imgs/tx2.png" alt="">
                        </div>
                        <p class="txt">提醒</p>
                      </a>
                    </div>
                    <div class="item">
                      <a :href="loginUrls.setting_url" target="_blank">
                        <div>
                          <img class="icon" src="@/assets/imgs/sz.png" alt="">
                        </div>
                        <p class="txt">设置</p>
                      </a>
                    </div>
                  </div> -->
                </div>
            </div>
            <!-- 图形验证码弹窗 -->
            <div class="randomMask" v-show="picMaskShow">
              <div class="randomContent">
                <div class="close" @click="close">
                	<img src="~@/assets/imgs/c2.png">
                </div>
                <div class="txt" style="text-align:left;margin-top: 10px;font-size: 12px;line-height: 30px;">请输入图形验证码后获取短信验证码</div>
                  <div class="code">
                    <img :src="codeImg" class="codePic" alt="">
                    <a href="javascript:;" class="change"  @click="changePic">换一个</a>
                  </div>
                  <div class="pas clear">
                    <input class="ipt fl" type="text" v-model="yzcode" placeholder="请输入图片中的内容"/>
                    <button class="pasBtn fl" @click="surePic">获取短信验证码</button>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import service from "@/api/service/service";
import { storageData } from "@/assets/js/storage";
export default {
  props: ["name","myuserInfo",'istrue'], //接收页面的路由name
  data() {
    return {
      tabIndex: 0,
      areaUserinfo:{},
      codeImg: "",
      noLogin: true, //未登录状态
      isLogin: false, //登录状态
      codeText: "获取验证码", //初始显示获取验证码，当点击后显示多少s后重发
      disabled: false,
      mobile: "", //
      randomStr: "", //随机验证码传的参数名
      yzcode: "", //输入的图片验证码
      time: 60,
      flag: 1, //当time为0时 初始值从1开始
      timer: null,
      picMaskShow: false, //图形验证码遮罩层
      codeNum: "",
      navsObj:JSON.parse(localStorage.getItem('navsObj')),
      loginUrls:JSON.parse(localStorage.getItem('loginUrls')),
      defaultImg:require('../../assets/imgs/noavatar_big.gif'),
    };
  },
  mounted() {
    // console.log('========LOGINBOX======')
    // console.log(storageData.getUserInfo())
    this.randomStr = this.randomStr2(18);
    if (storageData.getToken()) {
      this.isLogin = true;
      this.noLogin = false;
    } else {
      this.isLogin = false;
      this.noLogin = true;
    }
    // if(this.navsObj.site.id==1) {
    //   this.userInfo = this.myuserInfo
    // }else{
      // console.log(this.areaUserinfo)
      this.areaUserinfo=storageData.getUserInfo()
      // console.log(this.areaUserinfo)
      
    // }
  },
  computed: {
  },
  methods: {
    getdefaultImg() {
      let img = event.srcElement
      img.src = this.defaultImg
      img.onerror = null
    },
    close() {
      this.picMaskShow = false;
      this.yzcode = "";
    },
    randomStr2(len) {
      //生成随机字符串
      len = len || 32;
      var $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = $chars.length;
      var pwd = "";
      for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    changeLogin(index) {
      if (index == 0) {
        this.tabIndex = 0;
      } else {
        this.tabIndex = 1;
      }
      this.tabIndex = index;
    },
    exitLogin() {
      storageData.clearToken();
      storageData.clearUserInfo();
      this.delCookie("accessToken");
      this.noLogin = true;
      this.isLogin = false;
      // if(this.navsObj.site.id==1) {
      //   let url = `${this.loginUrls.login_url}&referer=${encodeURIComponent(window.location.href)}`
      //   window.open(url)
      // }else{
        this.$router.push({ path: "/arealogin" });
      // }
    },
    intoPerson(openId) {
      // if(this.navsObj.site.id==1) {
      //   let url = this.loginUrls.home_url
      //   window.open(url)
      // }else{
        let routeUrl = this.$router.resolve({
          path:`/pcenter?openId=${openId}&sid=${this.navsObj.site.id}`
        })
        window.open(routeUrl.href, '_blank');
      // }
      
    },
    changeTab(tabIndex) {
      // console.log(this.name)
      if (this.name == "index" || this.name == "personcenter") {
        this.$router.push({ path: "/follow" });
      } else {
        this.$emit("changeTab", tabIndex);
      }
    },
    surePic() {
      //获取短信验证码
      if (this.yzcode) {
        service
          .post(
            `${this.commonIp}/v1/checkCaptcha`,
            {
              randomStr: this.randomStr,
              captcha: this.yzcode,
            },
            false
          )
          .then((res) => {
            let data = res.data;
            if (data.code == "200") {
              clearInterval(this.timer);
              this.picMaskShow = false;
              this.getCode(1);
            }
            if (data.code == "420") {
              alert(data.message);
              this.changePic();
            }
            this.yzcode = "";
          });
      } else {
        alert("请输入图形验证码");
      }
    },
    changePic() {
      this.randomStr = this.randomStr2(18);
      let str = `${this.commonIp}/v1/captcha?randomStr=${this.randomStr}`;

      this.codeImg = str;
    },
    //倒计时方法
    countDown() {
      let _self = this;
      this.disabled = true;
      this.time = this.time - 1;
      this.codeText = this.time + "s后重发";
      if (this.time == 0) {
        this.codeText = "获取验证码";
        this.disabled = false;
        this.flag = 1;
        this.time = 60;
        return;
      }
      this.timer = setTimeout(() => {
        _self.countDown();
      }, 1000);
    },
    //检测是手机号
    checkMobile(mobile) {
      return RegExp(/^1[34578]\d{9}$/).test(mobile);
    },
    //获取验证码
    getCode(i) {
      let _self = this,
        params = {};
      if (!this.checkMobile(_self.mobile)) {
        //检验手机号
        alert("请输入正确的手机号");
        return;
      }
      if (i == 1) {
        params = {
          mobile: _self.mobile,
          from: "2", //2是快捷登录 //3是找回密码 1注册（会检查唯一性）
          randomStr: _self.randomStr,
          captcha: _self.yzcode,
        };
      } else if (i == 2) {
        params = {
          mobile: _self.mobile,
          from: "3",
          randomStr: _self.randomStr,
        };
      } else {
        params = {
          mobile: _self.mobile,
          from: "2",
          randomStr: _self.randomStr,
        };
      }
      service
        .post(`${this.commonIp}/v1/user/sendVerifyCode`, params, false)
        .then((res) => {
          // console.log(res.data);
          let data = res.data;
          if (data.code == "200") {
            this.countDown();
          } else if (data.code == "451") {
            //需要输入图形验证码
            _self.randomStr = _self.randomStr2(18);
            _self.picMaskShow = true;
            _self.codeImg = `${this.commonIp}/v1/captcha?randomStr=${
              _self.randomStr
            }`;
          }
        });
    },
    // 登录
    login() {
      // if(this.navsObj.site.id==1) {
      //   let url = `${this.loginUrls.login_url}&referer=${encodeURIComponent(window.location.href)}`
      //   window.location.href = url
      // }else{
        this.$router.push({ path: "/arealogin" });
      // }
    },
    //绑定手机号
    bindPhone() {
      let _self = this;
      if (!_self.mobile) {
        //没输入手机号
        alert("请输入手机号!");
      } else if (!_self.codeNum) {
        //没输入验证码
        alert("请输入验证码!");
      } else {
        service
          .post(
            `${this.commonIp}/v1/user/quickLogin`,
            {
              mobile: _self.mobile,
              verifyCode: _self.codeNum,
            },
            false
          )
          .then((res) => {
            // console.log(res.data);
            let data = res.data;
            if (data.code == "200") {
              storageData.setToken(data.data.token);
              // storageData.setUserInfo(data.data.user);
              // _self.areaUserInfo = data.data.user;
              _self.isLogin = true;
              _self.noLogin = false;
              _self.mobile = "";
              _self.codeNum = "";
            }
            if (data.code == "475") {
              //输入验证码错误
              // console.log(data.message);
              alert(data.message + "，请输入正确得验证码");
            }
          });
      }
    },
  },
};
</script>

<style lang="less">
@import "~@/assets/less/index.less";
#loginBox {
  .ornot_login {
    padding: 16px 15px;
    background: @bg45;
    position: relative;
    border-radius: 5px;
    z-index:1;
    // 图形验证码弹窗
    .randomMask {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99999;
      padding: 15px 15px;
      box-sizing: border-box;
      .randomContent {
        background-color: #fff;
        width: 100%;
        padding: 20px;
        overflow: hidden;

        .close {
          position: absolute;
          right: 5px;
          top: 5px;
          padding: 20px;
          img {
            cursor: pointer;
            width: 12px;
            height: 12px;
          }
        }
        .codePic {
          height: 40px;
          width: 70%;
          display: inline-block;
          vertical-align: middle;
        }
        button {
          background: none;
        }
        .change {
          font-size: 14px;
          color: #208bdc;
          display: inline-block;
          border: none;
          cursor: pointer;
        }
      }
      .pas {
        margin-top: 10px;
        display: block;
        .ipt {
          width: 100%;
          box-sizing: border-box;
          height: 40px;
          padding: 0 10px;
          border: 1px solid #333;
        }
        .pasBtn {
          border-radius: 5px;
          width: 100%;
          display: inline-block;
          line-height: 40px;
          height: 40px;
          margin-top: 10px;
          color: #fff;
          border: 0;
          font-size: 14px;
          background-color: #ea5d3c;
        }
      }
    }
    .login_inner {
      width: 100%;
      font-size: @ft12;
      color: #5c5c5c;
      .top {
        .avatar {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          vertical-align: middle;
          margin:0 10px 0 0;
        }
        .username{
          font-weight: bold;
          font-size:@fht18;
          color:@c4;
          padding-right:17px;
          cursor: pointer;
          line-height: 30px;
          background: url('~@/assets/imgs/ar.png') no-repeat right center;
          display: inline-block;
        }
      }
      .lcenter {
        display: flex;
        margin:20px 0 10px 0;
        .row {
          flex: 1;
          padding:11px 0 12px 10px;
          background: #fff;
          border-radius: 5px;
          &:nth-child(2n) {
            margin:0 8px 0;
          }
          p{
            text-align: left;
            &.num{
              font-weight: bold;
              font-size:@fht20;
              color:#444;
            }
            &.txt{
              margin:5px 0 0;
              font-size:@ft14;
              color:#505050;
            }
          }
        }
      }
      .bottom{
        display: flex;
        background:#fff;
        padding:10px 0;
        border-radius:5px;
        .item{
          flex:1;
          text-align:center;
          .icon{
            width:44px;
            height: 44px;
            border-radius:50%;
          } 
          .txt{
            font-size:@ft14;
            color:@c4;;
          }        
        }
      }
      .title {
        background-color: #fff;
        color: #5c5c5c;
        .titleLine {
          display: flex;
          height: 40px;
          line-height: 40px;
          a {
            flex: 1;
            text-align: center;
            font-size: 16px;
            color: #333;
            position: relative;
            &.active {
              color: #ea5d3c;
            }
            &.active::after {
              content: "";
              display: block;
              position: absolute;
              bottom: -2px;
              left: 0;
              width: 110px;
              height: 2px;
              background: #ea5d3c;
            }
          }
        }
      }
      p {
        text-align: center;
        cursor: pointer;
      }
      .noLoginBox{
        text-align: center;
        .noLogintxt{
          color:@c4;
          font-size:@ft20;
          margin:30px 0;
        }
        .btn {
          width: 128px;
          cursor: pointer;
          background:@hred;
          height: 40px;
          text-align: center;
          font-size: @ft20;
          color: #fff;
          margin:0 0 30px 0;
          border-radius: 3px;
        }
      }
      .third_box {
        width: 80%;
        margin: 0 auto;
        text-align: center;
        margin-top: 10px;
        .phone {
          cursor: pointer;
          height: 40px;
          line-height: 40px;
          .txt {
            background-color: #fafafa;
            border-radius: 5px;
            border: none;
            color: #333;
            height: 100%;
            padding: 0 5px;
            box-sizing: border-box;
          }
          .phoneTxt {
            width: 100%;
          }
          a {
            display: inline-block;
            width: 100%;
            color: #5c5c5c;
          }
          .icon_b {
            img {
              width: 30px;
            }
          }
        }
        .codeCon {
          display: inline-flex;
          margin-top: 10px;
          cursor: pointer;
          height: 40px;
          line-height: 40px;
          background-color: #fafafa;
          .txt {
            border-radius: 5px;
            border: none;
            color: #333;
            height: 100%;
            padding: 0 5px;
            box-sizing: border-box;
          }
          .codeTxt {
            width: 60%;
            background-color: #fafafa;
            position: relative;
            display: block;
            margin-right: 5px;
          }
          .getVerCode {
            color: #333;
            background-color: #fafafa;
            &.gray {
              color: #c8c8cd;
            }
          }
        }

        //扫码登录
        .codeBox {
          img {
            width: 150px;
            height: 150px;
            text-align: center;
          }
        }
      }
    }
    .gzBox {
      &.active {
        color: #ea5d3c;
      }

      &.active::after {
        content: "";
        display: block;
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 40px;
        height: 2px;
        background: #ea5d3c;
      }
      width: 90%;
      margin: 0 auto;
      .gzlist {
        float: left;
        width: 50%;
        font-size: @ft22;
        color: #323232;
        text-align: center;
        margin: 10px 0 0;
        &:first-child {
          border-right: 1px solid #efefef;
        }
        span {
          font-size: @ft12;
          display: block;
          color: #5c5c5c;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/loginBox.vue